import { render, staticRenderFns } from "./JoinSoccerTeam.vue?vue&type=template&id=00b3c4b8&scoped=true&"
import script from "./JoinSoccerTeam.vue?vue&type=script&lang=js&"
export * from "./JoinSoccerTeam.vue?vue&type=script&lang=js&"
import style0 from "./JoinSoccerTeam.vue?vue&type=style&index=0&id=00b3c4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3c4b8",
  null
  
)

export default component.exports